export default __webpack_public_path__ + "static/media/TulsiPot1.413c2e69.png";